import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { useNavigate, useLocation } from "react-router-dom";
const fileTypes = ["JPEG", "PNG", "GIF"];
const AssignmentCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [file, setFile] = React.useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">{location.state.type} assignment</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <FileUploader
                multiple={true}
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                color="red"
              />
              <p className="drop-file-heading">Drop your Task</p>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}></Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Select Class</p>
                <select className="input">
                  <option value="">Select</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Select Division</p>
                <select className="input">
                  <option value="">Select</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Student Name</p>
                <select className="input">
                  <option value="">Select</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Subject Name</p>
                <select className="input">
                  <option value="">Select</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Subject Name</p>
                <select className="input">
                  <option value="">Select</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Task name</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter your Task name"
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Remarks</p>
                <textarea
                  className="textarea"
                  placeholder="Enter about descriptions"
                  rows="20"
                  cols="40"
                ></textarea>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                {location.state.type === "Create" ? "Create" : "Update"}{" "}
                Assignment
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default AssignmentCreate;
